import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './ocorrenciaLogisticaForm';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { 
	setModoTela, initForm, salvar, excluir, 
	getLista, getListaUsuario, getListaTipo
} from './ocorrenciaLogisticaActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';
import consts from '../consts';

class OcorrenciaLogistica extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaUsuario();
		this.props.getListaTipo();
	}
	
	componentWillUnmount() {
	
	}

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
	
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ data_ocorrencia: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()) });
								}} />
						</Grid>
					</Row>

				</ContentCardHeader>
				<ContentCardBody>

					<Row>
						<Select
							options={this.props.listaUsuario}
							label='Usuário'
							cols='12 6 6 6'
							placeholder='Selecione o usuário'
							value={this.state.id_usuario}
							onChange={value => this.setState({ ...this.state, id_usuario: value })} />

					<Select
							options={this.props.listaTipo}
							label='Tipo'
							cols='12 6 6 6'
							placeholder='Selecione o tipo'
							value={this.state.id_tipo}
							onChange={value => this.setState({ ...this.state, id_tipo: value })} />

					</Row>
					
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Data</Th>
								<Th alignCenter>Usuário</Th>
								<Th alignCenter>Tipo</Th>
								<Th alignCenter>Descrição</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${DateFormat.formatarDataSqlParaTela(item.data_ocorrencia)}  ${item.nome_usuario || ''} ${item.descricao || ''} ${item.nome_tipo || ''}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								if (this.state.id_usuario && item.id_usuario != this.state.id_usuario) {
									return false;
								}
								if (this.state.id_tipo && item.id_tipo != this.state.id_tipo) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_ocorrencia)}</Td>
									<Td alignCenter>{item.nome_usuario}</Td>
									<Td alignCenter>{item.nome_tipo}</Td>
									<Td alignCenter>{item.descricao}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													data_ocorrencia: DateFormat.formatarDataSqlParaTela(item.data_ocorrencia)
												});
												this.props.initForm({
													...item,
													data_ocorrencia: DateFormat.formatarDataSqlParaTela(item.data_ocorrencia)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													data_ocorrencia: DateFormat.formatarDataSqlParaTela(item.data_ocorrencia)
												});
												this.props.initForm({
													...item,
													data_ocorrencia: DateFormat.formatarDataSqlParaTela(item.data_ocorrencia)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.ocorrenciaLogistica,
	modoTela: state.ocorrenciaLogistica.modoTela,
	lista: state.ocorrenciaLogistica.lista,
	listaUsuario: state.ocorrenciaLogistica.listaUsuario.filter(item => item.administrador),
    listaTipo: state.ocorrenciaLogistica.listaTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, 
	getLista, getListaUsuario, getListaTipo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(OcorrenciaLogistica);
